import { render, staticRenderFns } from "./TermoTela.vue?vue&type=template&id=52ca1086&"
import script from "./TermoTela.vue?vue&type=script&lang=js&"
export * from "./TermoTela.vue?vue&type=script&lang=js&"
import style0 from "./TermoTela.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports